var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import Box from "../box/Box";
import { theme } from "styled-tools";
import BgImage from "../image/BgImage";
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: ", "px;\n    margin-left: auto;\n    margin-right: auto;\n"], ["\n    max-width: ", "px;\n    margin-left: auto;\n    margin-right: auto;\n"])), theme("gridMaxWidth"));
export function Cards(_a) {
    var _b = _a.display, display = _b === void 0 ? ["block", "block", "block", "grid"] : _b, children = _a.children, before = _a.before, _c = _a.gridTemplateColumns, gridTemplateColumns = _c === void 0 ? "repeat(12, 1fr)" : _c, rest = __rest(_a, ["display", "children", "before", "gridTemplateColumns"]);
    return (React.createElement(Container, __assign({}, rest),
        before && React.createElement(Box, null, before),
        React.createElement(Box, { display: display, gridTemplateColumns: gridTemplateColumns, gridGap: 4 }, children)));
}
export function Card(_a) {
    var _b = _a.lazy, lazy = _b === void 0 ? true : _b, bgSrc = _a.bgSrc, href = _a.href, target = _a.target, children = _a.children, _c = _a.span, span = _c === void 0 ? 4 : _c, _d = _a.bgOverlay, bgOverlay = _d === void 0 ? true : _d, justifyContent = _a.justifyContent, _e = _a.overlayAlpha, overlayAlpha = _e === void 0 ? 0.4 : _e, rest = __rest(_a, ["lazy", "bgSrc", "href", "target", "children", "span", "bgOverlay", "justifyContent", "overlayAlpha"]);
    var style = {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "space-between",
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        padding: 24,
        textDecoration: "none",
        boxSizing: "border-box",
        zIndex: 1,
    };
    var component = React.createElement(href ? "a" : "div", {
        href: href,
        target: target,
        style: style,
        children: children,
    });
    return (React.createElement(BgImage, __assign({ lazy: lazy, mb: [4, 4, 4, 0], pt: "52.5%", position: "relative", bg: "black", src: bgSrc, backgroundRepeat: "no-repeat", backgroundSize: "cover", style: span !== "auto"
            ? {
                gridColumnEnd: "span ".concat(span),
            }
            : undefined }, rest),
        bgOverlay && (React.createElement(Box, { top: 0, left: 0, bg: "rgba(0,0,0,".concat(overlayAlpha, ")"), position: "absolute", width: "100%", height: "100%", zIndex: 0 }, "\u00A0")),
        component));
}
var templateObject_1;
//# sourceMappingURL=Cards.js.map